export default "__VITE_ASSET__BnhfGzBJ__"